import { useDealPortfolioStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";

const useDealPortfolioDelete = (): (id: number) => Promise<void> => {
    const dealPortfolioStore = useDealPortfolioStore();

    return async (id: number): Promise<void> => {
        try {
            await dealPortfolioStore.deletePortfolio(id);
            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useDealPortfolioDelete;
